import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import QueueItem from 'PointOfSale/modules/queue/component/QueueItem';

const QueueContainer = ({
  queue,
  onQueueItemClick,
  currentProfile,
  showDetails,
}) => {
  const { profile } = currentProfile;
  return (
    <div className="profile-page-queue flex-1">
      {_.map(queue, (data, index) => {
        if (showDetails && profile && data.Id === profile.Id) {
          return null;
        }
        return (
          <div onClick={() => onQueueItemClick(index)} key={index}>
            <QueueItem data={data} isActive={index === 0} />
          </div>
        );
      })}
    </div>
  );
};

QueueContainer.propTypes = {
  queue: PropTypes.array,
  onQueueItemClick: PropTypes.func,
  showDetails: PropTypes.bool,
  isProfilePage: PropTypes.bool,
};

export default QueueContainer;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/queue/component/QueueContainer.js